import React, { useState } from 'react';
import { TrendingUp } from 'lucide-react';
import { Card } from '../ui/card';
import { useRepStats, PeriodToggle } from './useRepStats';

const STATS = [
  ['brains_saved', 'Brains Saved', 'text-slate-900'],
  ['invites_sent', 'Links Sent', 'text-slate-900'],
  ['signups', 'Signups', 'text-blue-600'],
  ['paid', 'Paid Customers', 'text-green-600'],
];

export const MyRepStats = ({ token }) => {
  const [period, setPeriod] = useState('month');
  const me = useRepStats(token, period)?.me;

  return (
    <Card className="p-6 bg-white border-slate-200" data-testid="my-rep-stats">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-green-100 flex items-center justify-center">
            <TrendingUp className="w-5 h-5 text-green-600" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-slate-900">My Performance</h2>
            <p className="text-sm text-slate-500">Your demos turning into customers</p>
          </div>
        </div>
        <PeriodToggle period={period} setPeriod={setPeriod} />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {STATS.map(([k, label, color]) => (
          <div key={k} className="p-4 rounded-lg bg-slate-50 border border-slate-100">
            <p className={`text-2xl font-bold ${color}`} data-testid={`my-stat-${k}`}>{me ? me[k] : '–'}</p>
            <p className="text-xs text-slate-500 mt-1">{label}</p>
          </div>
        ))}
      </div>
    </Card>
  );
};
